<div class="confirm-download-final-dialog">
  <mat-horizontal-stepper #stepper>

    <mat-step [completed]="false">
      <ng-template matStepLabel>belangrijk</ng-template>
      <div class="step">
        <h2>weet u het zeker?</h2>
        <p>zodra de definitieve versie van een rapportage is aangemaakt kan deze enkel op verzoek van de rechtbank
          worden gewijzigd.</p>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button (click)="sure()" *ngIf="summary" class="btn check accent">Ik weet het zeker</button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false" *ngIf="summary && summary?.deviation != 0">
      <ng-template matStepLabel>afwijking</ng-template>
      <div class="step">
        <h2>er is een afwijking aangetroffen</h2>
        <table class="col-2-monospace spaced-table w800 auto">
          <tr><td>totaal netto inkomen (A)</td><td>{{euro(summary.income)}}</td></tr>
          <tr><td>totaal uitgaven (B)</td><td>{{euro(summary.expenses)}}</td></tr>
          <tr><td>verschil (C)</td><td>{{euro(summary.differenceIncomeExpenses)}}</td></tr>
          <tr><td>totaal rekeningen einddatum (E)</td><td>{{euro(summary.endAmount)}}</td></tr>
          <tr><td>totaal rekeningen begindatum (D)</td><td>{{euro(summary.startAmount)}}</td></tr>
          <tr><td>verschil (F)</td><td>{{euro(summary.differenceStartEndAmount)}}</td></tr>
          <tr><td>F - C is</td><td>{{euro(summary.deviation)}}</td></tr>
        </table>
        <p>controleer of alle transacties zijn ingelezen of neem contact met ons op</p>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button (click)="dialogRef.close()" routerLink="/contact" class="btn check accent">neem contact op</button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false">
      <ng-template matStepLabel>controle transacties</ng-template>
      <div class="step">
        <h2>zijn alle gegevens geïmporteerd?</h2>
        <table class="table table-hover" style="width: 80%; margin: auto;">
          <thead>
          <tr>
            <th>rekening</th>
            <th>IBAN</th>
            <th>eerste</th>
            <th>laatste</th>
            <th>aantal</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let ts of transactionSpans">
            <td>{{ts.name.toLocaleLowerCase()}}</td>
            <td>{{ts.iban}}</td>
            <td>{{ts.first}}</td>
            <td>{{ts.last}}</td>
            <td>{{ts.count}}</td>
          </tr>
          </tbody>
        </table>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button (click)="stepper.next()" class="btn check accent">alle transacties zijn geïmporteerd</button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false">
      <ng-template matStepLabel>concept</ng-template>
      <div>
        <h2 style="padding-top: 20px">controleer het concept rapport - scroll naar beneden om door te gaan</h2>
        <app-progress [progress]="progress" [status]="allPagesViewed ? 'DONE' : ''"></app-progress>
        <div class="spacer-small"></div>
        <div>
          <mat-spinner *ngIf="totalPages == 1" diameter="100" color="#03738c" class="spinner"></mat-spinner>
          <pdf-viewer (after-load-complete)="afterLoadComplete($event)"
                      (pageChange)="pageChange($event)"
                      [(page)]="currentPreviewPage"
                      [render-text]="true"
                      zoom-scale="page-width"
                      [original-size]="false"
                      [show-borders]="true"
                      [src]="pdfSource"
                      [stick-to-page]="true"
                      class="pdf-viewer"
                      style="display: block;"></pdf-viewer>
        </div>
        <div class="spacer"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button [disabled]="!allPagesViewed"
                  [matTooltipDisabled]="allPagesViewed"
                  class="btn check accent"
                  matStepperNext
                  matTooltip="U kunt pas verder gaan als alle pagina's gecontroleerd zijn">
            ik heb het rapport gecontroleerd
          </button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false" *ngIf="hasOtherTransactions">
      <ng-template matStepLabel>overige inkomsten en uitgaven</ng-template>
      <div class="step">
        <app-other-transaction-list [clientId]="data.clientId"
                                    [reportType]="data.type"
                                    [year]="data.year">
        </app-other-transaction-list>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button (click)="stepper.next()" *ngIf="summary" class="btn check accent">ik ga de transacties in de bijlage toelichten</button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false">
      <ng-template matStepLabel>algemene voorwaarden</ng-template>
      <div class="step">
        <h2>Controle</h2>
        <div class="form form-no-width" style="width: 800px; margin: auto;">
          <div *ngFor="let check of checks">
            <label class="unselectable"><input [(ngModel)]="check['value']" type="checkbox">{{check.label}}</label>
          </div>
        </div>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" class="btn times">annuleer</button>
          <button (click)="downloadFinal()"
                  [disabled]="!allChecked()"
                  [matTooltipDisabled]="allChecked()"
                  class="btn check accent"
                  matTooltip="Ga akkoord met de voorwaarden">maak definitief rapport</button>
        </div>
      </div>
    </mat-step>

    <mat-step [completed]="false">
      <ng-template matStepLabel>Bedankt</ng-template>
      <div class="step">
        <h2>Bedankt, uw rapport is definitief gemaakt</h2>
        <p>
          Het rapport is naar uw computer gedownload en is klaar om ter controle bij de rechtbank te worden ingediend.
          <br>
          Het indienen van de rapportage gebeurt niet door Reveon.
        </p>
        <div class="spacer-large"></div>
        <div class="buttons">
          <button (click)="dialogRef.close()" [routerLink]="'/bewind/' + data.clientId + '/rapportage'"
                  class="btn check accent">Sluiten
          </button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
